module.exports = __webpack_public_path__ + "static/media/ticket_free.d75db77f.svg";